"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.validateTransform = void 0;
const common_1 = require("@finley-technologies/common");
const errorUtils_1 = require("./errorUtils");
const validateTransform = (transformation) => {
    const errors = [];
    const { fields, delimiter } = transformation;
    const effectiveSeparator = delimiter || ',';
    if (fields.length === 0) {
        errors.push({
            type: 'metadataValidation',
            message: 'attachHeader: at-least 1 field is required',
        });
    }
    fields.forEach((field, index) => {
        // we don't want to allow empty strings
        if (field.trim() === '') {
            errors.push({
                type: 'metadataValidation',
                message: `attachHeader: fields[${index}] cannot be empty`,
            });
        }
        // ensure that field does not have invalid characters
        const invalidCharacters = ['\n', '\r', effectiveSeparator];
        invalidCharacters.forEach((char) => {
            if (field.includes(char)) {
                errors.push({
                    type: 'metadataValidation',
                    message: `attachHeader: fields[${index}] contains invalid character(s)`,
                });
            }
        });
    });
    if (errors.length > 0) {
        return {
            isValid: false,
            errors,
        };
    }
    return { isValid: true, data: null };
};
exports.validateTransform = validateTransform;
const performTransform = async ({ dataTapeBuffers, transformation, }) => {
    try {
        (0, common_1.finleyAssert)(dataTapeBuffers.length === 1, 'Expected 1 data tape buffer');
        const srcDataTapeBuffer = dataTapeBuffers[0];
        const { fields, delimiter } = transformation;
        const effectiveSeparator = delimiter || ',';
        const headerString = fields.join(effectiveSeparator);
        const headerBuffer = common_1.finleyBuffer.fromString(`${headerString}\n`);
        // generate the output buffer by concatenating the header buffer and the input buffer
        const outputBuffer = new Uint8Array(headerBuffer.length + srcDataTapeBuffer.length);
        outputBuffer.set(headerBuffer);
        outputBuffer.set(srcDataTapeBuffer, headerBuffer.length);
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (error) {
        // there are no errors to consolidate.
        // just convert the error to a structured error
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'attachHeader: ');
    }
};
exports.transformOperation = {
    operation: 'attachHeader',
    validateTransform: exports.validateTransform,
    performTransform,
};
//# sourceMappingURL=attachHeader-transform.js.map